(() => {
  const normalize = (value) => (value || '').trim().toLowerCase();

  const initializeDirectory = (directory) => {
    if (directory.dataset.initialized === 'true') return;
    directory.dataset.initialized = 'true';

    const cards = [...directory.querySelectorAll('[data-partner-card]')];
    const buttons = [...directory.querySelectorAll('[data-partner-filter]')];
    const search = directory.querySelector('[data-partner-search]');
    const noResults = directory.querySelector('[data-partner-no-results]');
    const resultCount = directory.querySelector('[data-partner-count]');
    let activeType = 'all';

    const update = () => {
      const query = normalize(search?.value);
      let visibleCount = 0;

      cards.forEach((card) => {
        const matchesType = activeType === 'all' || card.dataset.partnerType === activeType;
        const matchesQuery = !query || normalize(card.dataset.partnerSearchText).includes(query);
        const isVisible = matchesType && matchesQuery;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (noResults) noResults.classList.toggle('hidden', cards.length === 0 || visibleCount > 0);
      if (resultCount) {
        resultCount.textContent = `${visibleCount} ${visibleCount === 1 ? 'partner' : 'partners'} shown`;
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        activeType = button.dataset.partnerFilter;
        buttons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        update();
      });
    });

    search?.addEventListener('input', update);
    update();
  };

  const initializeDirectories = (scope = document) => {
    scope.querySelectorAll('[data-partner-directory]').forEach(initializeDirectory);
  };

  initializeDirectories();
  document.addEventListener('shopify:section:load', (event) => initializeDirectories(event.target));
})();
